<template lang="pug">
#filtrar-inteligencia-territorial
    .filtrar-inteligencia-territorial-container
        .filtrar-inteligencia-territorial-input-container
            .filtrar-inteligencia-territorial__input
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder="$t('mensagens.inteligenciaTerritorial.pesquisaInteligente.placeholder')",
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

            .filtrar-inteligencia-territorial__resultado
                transition(name='el-zoom-in-top')
                    ul.filtrar-inteligencia-territorial__ul(
                        v-show='mostrarResultado'
                    )
                        .mb-2(v-if='resultadosPesquisa?.localidadeNivel2.length')
                            span.filtrar-inteligencia-territorial__categoria {{ $t('mensagens.inteligenciaTerritorial.municipioLocalidade') }}

                            li(
                                v-for='municipio in resultadosPesquisa?.localidadeNivel2',
                                @click='selecionarResultadoPesquisaInteligente(municipio, `MUNICIPIO`)'
                            )
                                span {{ formatarMunicipio(municipio) }}
                        .mb-2(v-if='resultadosPesquisa?.localidadeNivel1.length')
                            span.filtrar-inteligencia-territorial__categoria {{ $t('mensagens.inteligenciaTerritorial.estadoDepartamento') }}

                            li(
                                v-for='estado in resultadosPesquisa?.localidadeNivel1',
                                @click='selecionarResultadoPesquisaInteligente(estado, `ESTADO`)'
                            )
                                span {{ estado?.nomeNivel1 }}
                        .mb-2(v-if='resultadosPesquisa?.car.length')
                            span.filtrar-inteligencia-territorial__categoria CARs

                            li(
                                v-for='car in resultadosPesquisa.car',
                                @click='selecionarResultadoPesquisaInteligente(car, `CAR`)'
                            )
                                span {{ car.codigo }}
        FiltroAvancadoInteligenciaTerritorial(:isLoading='isLoading')
    .filtrar-inteligencia-territorial-filtro-selecionado
        span.filtrar-inteligencia-territorial-filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
        el-tag.filtrar-inteligencia-territorial-filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ formatarNomeTag(tag?.nome) }}

        el-tag.filtrar-monitoramento-socioambiental-filtro-selecionado__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.inteligenciaTerritorial.pesquisaInteligente.limparFiltros') }} &nbsp
            i.el-icon-delete

        span.filtrar-inteligencia-territorial-filtro-selecionado__nenhum(
            v-else
        ) {{ $t('mensagens.inteligenciaTerritorial.pesquisaInteligente.nenhumFiltroSelecionado') }}
</template>

<script>
import InteligenciaTerritorialService from '@/services/InteligenciaTerritorialService';
import MunicipioService from '@/services/MunicipioService';

import FiltroAvancadoInteligenciaTerritorial from '@/components/inteligenciaTerritorial/FiltroAvancadoInteligenciaTerritorial.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'FiltrarInteligenciaTerritorial',
    emits: ['remover-tag'],
    components: {
        FiltroAvancadoInteligenciaTerritorial
    },
    props: {
        tags: {
            type: Array,
            default: () => []
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            pesquisa: '',
            resultadosPesquisa: {
                localidadeNivel2: [],
                localidadeNivel1: [],
                car: []
            },
            resultadosSelecionados: [],
            mostrarResultado: false,
            limparEstado: false,
            limparMunicipio: false,
            limparRestricaoSocioambiental: false,
            municipioData: null
        };
    },
    computed: {
        ...mapState({
            filtroState: state => state.filtroInteligenciaTerritorial
        })
    },
    methods: {
        ...mapActions(['setFiltroInteligenciaTerritorial']),

        async buscarMunicipio(id) {
            try {
                await MunicipioService.getMunicipioById(id).then(({ data }) => {
                    this.municipioData = data;
                    return data.id;
                });
            } catch (e) {
                return '';
            }
        },

        async pesquisar() {
            if (!this.pesquisa) {
                return this.limpar();
            }
            const { data } = await InteligenciaTerritorialService.pesquisar(
                this.pesquisa
            );
            this.resultadosPesquisa = data;
            let existeRetorno =
                data?.car.length !== 0 ||
                data?.localidadeNivel1.length !== 0 ||
                data?.localidadeNivel2.length !== 0;
            this.mostrarResultado = existeRetorno;
            let quantidadeCaracteresCAR = 43;
            let quantidadeCaracteresDaMaiorCidade = 32;
            let tamanhoPesquisa = this.pesquisa.length;
            if (
                !existeRetorno &&
                this.pesquisa.length === quantidadeCaracteresCAR
            ) {
                this.$notify.error({
                    message: this.$t('mensagens.inteligenciaTerritorial.erro.carNaoEncontrado')
                });
            } else if (
                tamanhoPesquisa > quantidadeCaracteresDaMaiorCidade &&
                (tamanhoPesquisa > quantidadeCaracteresCAR ||
                    tamanhoPesquisa < quantidadeCaracteresCAR)
            ) {
                this.exibirNotify(
                    'warning', this.$t('mensagens.inteligenciaTerritorial.erro.informacaoInvalida')
                );
            } else if (!existeRetorno) {
                this.exibirNotify(
                    'warning', this.$t('mensagens.inteligenciaTerritorial.erro.naoForamEncontradosResultadosComTextoInformado')
                );
            }
            if (this.resultadosPesquisa?.car.length > 0) {
                await this.buscarMunicipio(this.resultadosPesquisa?.car[0].idMunicipio);
                let filtro = {
                    ...this.filtroState,
                    tipoAgrupamento: null,
                    idsMunicipios: [this.resultadosPesquisa.car[0].idMunicipio],
                    nome: this.municipioData?.nome + '-' + this.municipioData?.estado.sigla,
                    objMunicipio: {
                        id: this.municipioData?.id,
                        nome: this.municipioData?.nome
                    },
                    siglaEstado: this.municipioData?.estado.sigla || null,
                    codigosCars: [this.resultadosPesquisa.car[0].codigo]
                };
                this.setFiltroInteligenciaTerritorial(filtro);
                this.$router.push({
                    name: 'InteligenciaTerritorialImovel',
                    params: {
                        uf: this.resultadosPesquisa.car[0].uf,
                        codMunicipioIbge:
                            this.resultadosPesquisa?.car[0].idMunicipio,
                        car: this.resultadosPesquisa?.car[0].codigo
                    }
                });
            }
        },
        selecionarResultadoPesquisaInteligente(resultado, tipo) {
            let filtro = {};
            if (tipo === 'MUNICIPIO') {
                filtro = {
                    ...this.filtroState,
                    tipoAgrupamento: 'MUNICIPIO',
                    nome: resultado.nomeNivel2 + '-' + resultado?.siglaNivel1,
                    idsMunicipios: [resultado?.codigoNivel2],
                    siglaEstado: resultado?.siglaNivel1,
                    estadoId: resultado?.idNivel1,
                    objEstado: { id: resultado?.idNivel1, sigla: resultado?.siglaNivel1 },
                    municipioSelecionado: { id: resultado?.codigoNivel2, nome: resultado?.nomeNivel2 },
                    codigosCars: []
                };
                this.setFiltroInteligenciaTerritorial(filtro);
            }
            if (tipo === 'ESTADO') {
                filtro = {
                    ...this.filtroState,
                    tipoAgrupamento: 'ESTADO',
                    nome: resultado?.nomeNivel1,
                    estadoId: resultado?.idNivel1,
                    objEstado: { id: resultado?.idNivel1, sigla: resultado?.siglaNivel1 },
                    siglaEstado: resultado?.siglaNivel1,
                    municipioSelecionado: null,
                    idsMunicipios: [],
                    codigosCars: []
                };
                this.setFiltroInteligenciaTerritorial(filtro);
            }
        },
        limpar() {
            this.mostrarResultado = false;
            this.resultadosPesquisa = {
                localidadeNivel2: [],
                localidadeNivel1: [],
                car: []
            };
        },
        fecharLista() {
            // Necessário apenas por UX
            setTimeout(() => {
                this.mostrarResultado = false;
                this.resultadosPesquisa = {
                    localidadeNivel2: [],
                    localidadeNivel1: [],
                    car: []
                };
            }, 300);
        },
        exibirNotify(tipo, message) {
            this.$notify[tipo]({ message });
        },
        formatarMunicipio(municipio) {
            if (this.resultadosPesquisa?.localidadeNivel2.length > 1) {
                return municipio?.nomeNivel2 + ', ' + municipio?.siglaNivel1;
            } else {
                return municipio?.nomeNivel2;
            }
        },
        removerFiltro(tag) {
            if (
                tag?.codigo !== this.cultura &&
                tag?.codigo !== 'POSSUI_RESTRICOES'
            ) {
                this.pesquisa = '';
            }
            if (tag?.codigo === 'ESTADO') {
                this.limparEstado = true;
            }
            if (tag?.codigo === 'MUNICIPIO') {
                this.limparMunicipio = true;
            }
            if (tag?.codigo === 'POSSUI_RESTRICOES') {
                this.limparRestricaoSocioambiental = true;
            }
            this.$emit('remover-tag', tag);
        },
        limparFiltros() {
            [...this.tags].forEach(tag => this.removerFiltro(tag));
            this.$store.dispatch('limparFiltroInteligenciaTerritorial');
        },
        formatarNomeTag(nome) {
            return nome;
        }
    }
};
</script>

<style lang="scss" scoped>
.filtrar-inteligencia-territorial-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-inteligencia-territorial-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-inteligencia-territorial__resultado {
    position: absolute;
    width: 100%;
}

.filtrar-inteligencia-territorial__resultado__nome {
    margin: 0 10px;
}

.filtrar-inteligencia-territorial__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-inteligencia-territorial__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.filtrar-inteligencia-territorial__categoria {
    font-weight: bold;
}

.filtrar-inteligencia-territorial-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;

    .filtrar-monitoramento-socioambiental-filtro-selecionado__limpar {
        cursor: pointer;
    }
}

.filtrar-inteligencia-territorial-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-inteligencia-territorial-filtro-selecionado__tag {
    margin: 0 5px 10px 5px;
}

.filtrar-inteligencia-territorial-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.filtrar-inteligencia-territorial-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-inteligencia-territorial-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }

    .filtrar-inteligencia-territorial-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.filtrar-inteligencia-territorial-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox {
        margin-right: 12px !important;
        min-width: 200px;
    }

    .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.filtrar-inteligencia-territorial-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-item__possui-alertas {
    display: flex;
    gap: 24px;
}

.el-collapse-item__safras--loading {
    min-height: 100px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}
</style>
